import Box from '~/components/UI/Box'

export default Box
